/**
 * When to filter rows for smaller screens.
 * Based on `window.innerWidth`
 */
export const SHOW_CURRENT_COLORS_BREAKPOINT = 642;
